// extracted by mini-css-extract-plugin
export default {"weekDaysItem":"WeekDayHeader_weekDaysItem__TXLOL","weekendDayItem":"WeekDayHeader_weekendDayItem__WXx0q"};